var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTeenDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Dating-Smartphone-Chat--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dating Smartphone Chat Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 0H10a2 2 0 0 0 -2 2v7a2 2 0 0 0 2 2h2.5a0.5 0.5 0 0 1 0.5 0.5v2a0.5 0.5 0 0 0 0.31 0.46 0.49 0.49 0 0 0 0.54 -0.11l2.56 -2.56a1.05 1.05 0 0 1 0.71 -0.29H22a2 2 0 0 0 2 -2V2a2 2 0 0 0 -2 -2Zm-5.55 8.82a0.72 0.72 0 0 1 -0.9 0C14.51 8 12 5.81 12 4.1c0 -2.15 2.45 -3 3.58 -1.27a0.5 0.5 0 0 0 0.84 0C17.55 1.07 20 2 20 4.1c0 1.71 -2.51 3.9 -3.55 4.72Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5h-1a0.5 0.5 0 0 0 -0.5 0.5v4a0.5 0.5 0 0 1 -0.5 0.5H2.5A0.5 0.5 0 0 1 2 20V6.5a0.5 0.5 0 0 1 0.5 -0.5H6a0.5 0.5 0 0 0 0.5 -0.5v-2A0.5 0.5 0 0 0 6 3H3a3 3 0 0 0 -3 3v15a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3 -3v-5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTeenDrama);
export default ForwardRef;